export const filterRequests = (organizations, id) =>(organizations.filter( org => org.id !== id))